/** Taxonomie partagée par la cartographie publique (PublicOrganizationType) et les fiches
 * annuaire (OrganizationProfile.organizationType, ORGANIZATION_TYPE_CODES) — mêmes 8 codes côté
 * profile-service. */
const ORGANIZATION_TYPE_LABEL_KEYS: Record<string, string> = {
  PARTNER: 'pages.cartography.organizationTypes.partner',
  INSTITUTION: 'pages.cartography.organizationTypes.institution',
  STARTUP: 'pages.cartography.organizationTypes.startup',
  TPME: 'pages.cartography.organizationTypes.tpme',
  ASSOCIATION: 'pages.cartography.organizationTypes.association',
  TRAINING_CENTER: 'pages.cartography.organizationTypes.trainingCenter',
  INCUBATOR: 'pages.cartography.organizationTypes.incubator',
  DONOR: 'pages.cartography.organizationTypes.donor',
};

/** Clé i18n (`pages.cartography.organizationTypes.*`, public/i18n/*.json), ou `null` si le code est inconnu (repli sur le code brut). */
export function organizationTypeLabelKey(type: string | null | undefined): string | null {
  if (!type) return null;
  return ORGANIZATION_TYPE_LABEL_KEYS[type] ?? null;
}
